import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { useNotification } from "../contexts/NotificationContext";
import { addEvent, AddEventType } from "../services/api";
import "../stylesheets/addEventForm.scss";

// TYPES

import { ChangeEvent, FormEvent, useState } from "react";

type AddEventFormProps = {
	onClose: () => void;
};

// COMPONENT

function AddEventForm({ onClose }: AddEventFormProps) {
	const { notify } = useNotification();
	// STATES
	const [visible, setVisible] = useState<boolean>(true);
	const [image, setImage] = useState<File | undefined>(undefined);
	// HANDLES
	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const data = new FormData(e.currentTarget);
		const title = data.get("title") as string;
		const date = data.get("date") as string;
		const description = data.get("description") as string;
		const newEvent: AddEventType = {
			title,
			date,
			description,
		};
		const response = await addEvent(newEvent, image);
		if (response) {
			notify({ type: "validation", title: "Évènement ajouté!" });
		} else {
			notify({
				type: "error",
				title: "Impossible d'ajouter l'évènement...",
			});
		}
	};
	const handleFileSelected = (e: ChangeEvent<HTMLInputElement>) => {
		const files = e.currentTarget.files;
		if (files) {
			setImage(files[0]);
		}
	};
	return (
		<form className="add-event-form" onSubmit={(e) => handleSubmit(e)}>
			<div className="title-date">
				<input type="text" name="title" placeholder="titre" />
				<input type="date" name="date" />
			</div>
			<input
				type="file"
				accept=".png, .jpg, .jpeg"
				placeholder="choose"
				onChange={(e) => handleFileSelected(e)}
			/>
			<textarea name="description" placeholder="décrivez l'évènement" />
			{image && <img></img>}
			<button type="submit">ajouter</button>
			<button
				className="close-form"
				onClick={(e) => {
					onClose();
				}}
			>
				<CloseIcon />
			</button>
		</form>
	);
}

export default AddEventForm;
